import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { invoke } from 'lodash';
import Columns from './Columns';
import Image from '../../../../Image';
import { toggleQuestionCollapse } from '../utils';
import { isRowValuesFilled } from '../isValid';

export default function OpenEndedNumeric({
  rows,
  openEndedStyle,
  openEndedInputSize,
  openEndedSignPlacement,
  openEndedSign,
  min,
  max,
  decimals,
  showRequiredInputSymbol,
  getText,
}) {
  const lastIndex = rows.length - 1;

  const onClickRowLabel = useCallback((event) => {
    toggleQuestionCollapse(event.target);
  }, []);

  const checkFocusAndToggle = useCallback((event) => {
    const originParent = invoke(
      event.target,
      'closest',
      '.answer--matrix-open-ended',
    );
    const destinationParent = invoke(
      event.relatedTarget,
      'closest',
      '.answer--matrix-open-ended',
    );
    if (originParent !== destinationParent && isRowValuesFilled(originParent)) {
      // a bit of a hack to reuse the same toggleQuestionCollapse function
      const toggleButton = originParent.querySelector(
        '.answer--matrix-open-ended-row-label',
      );
      toggleQuestionCollapse(toggleButton);
    }
  }, []);

  return (
    <div className="answers">
      {rows.map((row, index) => {
        const isEmptyLabel = !row.label || row.label === '<div></div>';

        return (
          <Fragment>
            <div
              id={row.id}
              className="answer--matrix-open-ended"
              onBlur={checkFocusAndToggle}
            >
              {!isEmptyLabel && (
                <button
                  type="button"
                  className="answer--matrix-open-ended-row-label formatted-answers-inline"
                  onClick={onClickRowLabel}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: row.label || '&nbsp;' }}
                />
              )}
              <div className="answer--matrix-open-ended-content-wrapper">
                <Image row={row} />
                <Columns
                  rowId={row.id}
                  rowRefId={row.refId}
                  rowOrder={index}
                  columns={row.columns}
                  openEndedStyle={openEndedStyle}
                  openEndedInputSize={openEndedInputSize}
                  openEndedSignPlacement={openEndedSignPlacement}
                  openEndedSign={openEndedSign}
                  min={min}
                  max={max}
                  decimals={decimals}
                  showRequiredInputSymbol={showRequiredInputSymbol}
                />
              </div>
            </div>
            {lastIndex > index && <div className="divider margin-md"></div>}
          </Fragment>
        );
      })}
      {!showRequiredInputSymbol && (
        <div className="answer--matrix-open-ended-info-message-missing" />
      )}
      {showRequiredInputSymbol && (
        <span className="answer--matrix-open-ended-info-message">
          <span>* {getText('warnings.matrixNumericOpenEndedNote')}</span>
        </span>
      )}
    </div>
  );
}

OpenEndedNumeric.propTypes = {
  rows: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  openEndedSign: PropTypes.string,
  openEndedSignPlacement: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
  showRequiredInputSymbol: PropTypes.bool,
  getText: PropTypes.func,
};
